import axios from 'axios';
import axiosInstance from 'services/axiosConfig';
import { createAsyncThunk } from '@reduxjs/toolkit';

import handleError from 'services/handleError';

export const getUserData = createAsyncThunk(
  'userdata/getUserData',

  async (_, thunkAPI) => {
    try {
      const { data } = await axios.get(`/user/profile/read`);

      return data;
    } catch (error) {
      if (!error.response) {
        return thunkAPI.rejectWithValue({
          message:
            'Network error. Please check your internet connection or try again later.',
          errorType: error.code || 'network_error',
          details: error.message,
        });
      }

      const status = error.response?.status;
      const data = error.response?.data;

      const errorDetails = await handleError(status, data);

      return thunkAPI.rejectWithValue(errorDetails);
    }
  }
);

export const changeUserData = createAsyncThunk(
  'userdata/changeUserData',

  async (userData, thunkAPI) => {
    try {
      await axios.post(`/user/profile/update`, userData);

      return userData;
    } catch (error) {
      if (!error.response) {
        return thunkAPI.rejectWithValue({
          message:
            'Network error. Please check your internet connection or try again later.',
          errorType: error.code || 'network_error',
          details: error.message,
        });
      }

      const status = error.response?.status;
      const data = error.response?.data;

      const errorDetails = await handleError(status, data);

      return thunkAPI.rejectWithValue(errorDetails);
    }
  }
);

export const subscriptionCreate = createAsyncThunk(
  'subscription/create',

  async (planType, thunkAPI) => {
    try {
      const { data } = await axios.post(`/subscription/create`, planType);

      return data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response);
    }
  }
);

export const subscriptionUpdate = createAsyncThunk(
  'subscription/update',

  async (planType, thunkAPI) => {
    try {
      const response = await axios.post(`/subscription/update`, planType);

      return { status: response.status };
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response);
    }
  }
);

export const subscriptionRenew = createAsyncThunk(
  'subscription/renew',

  async (_, thunkAPI) => {
    try {
      const response = await axios.post(`/subscription/renew`);

      return { status: response.status };
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response);
    }
  }
);

export const buyOneTimePackage = createAsyncThunk(
  'subscription/buyOneTimePackage',

  async (planType, thunkAPI) => {
    try {
      const { data } = await axiosInstance.post(
        `/shopify/payments/create`,
        planType
      );
      console.log('buyOneTimePackage Operation response data:', data);

      return data;
    } catch (error) {
      console.log('buyOneTimePackage Operation error:', error);
      return thunkAPI.rejectWithValue(error.response);
    }
  }
);

export const subscriptionCancel = createAsyncThunk(
  'subscription/cancel',

  async (_, thunkAPI) => {
    try {
      const response = await axios.post(`/subscription/cancel`);

      return { status: response.status };
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response);
    }
  }
);

export const subscriptionRecover = createAsyncThunk(
  'subscription/recover',

  async (_, thunkAPI) => {
    try {
      const response = await axios.post(`/subscription/recover`);

      return { status: response.status };
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response);
    }
  }
);

export const getBillingPortalUrl = createAsyncThunk(
  'user/billingPortal',

  async (_, thunkAPI) => {
    try {
      const { data } = await axios.get(`/user/billing/portal`);

      return data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.response);
    }
  }
);
